import Input from './Input/components/Input.css';
import RadioButton from './RadioButton/components/RadioButton.css';
import Checkbox from './Checkbox/components/Checkbox.css';
import Dropdown from './Dropdown/components/Dropdown.css';
import Button from './Button/components/Button.css';
import CloseButton from './Button/components/CloseButton/CloseButton.css';
import BackwardButton from './Button/components/BackwardButton/BackwardButton.css';
import IconButton from './Button/components/IconButton/IconButton.css';
import TurnButton from './Button/components/TurnButton/TurnButton.css';
import Breadcrumbs from './Breadcrumbs/Breadcrumbs.css';
import BreadcrumbItem from './Breadcrumbs/BreadcrumbItem/BreadcrumbItem.css';
import Loader from './Button/components/Loader/Loader.css';
import Snackbar from './Snackbar/components/Content/Content.css';
import Tooltip from './Tooltip/Tooltip.css';
import SexSelector from './SexSelector/components/SexSelector.css';
import ModalX from './ModalX/components/ModalX.css';
import Header from './Header/components/Header.css';
import FullscreenModalHeader from './Header/components/FullscreenModalHeader/FullscreenModalHeader.css';
import Footer from './Footer/components/Footer.css';
import Content from './Content/components/Content.css';
import Notification from './Notification/Notification.css';

export default {
	Input,
	Dropdown,
	Button,
	CloseButton,
	BackwardButton,
	IconButton,
	TurnButton,
	Loader,
	RadioButton,
	Checkbox,
	Breadcrumbs,
	BreadcrumbItem,
	SexSelector,
	ModalX,
	Snackbar,
	Tooltip,
	Header,
	FullscreenModalHeader,
	Content,
	Footer,
	Notification
};
